// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d72c197b","312":"e13afcc5","716":"a95f0559","853":"8e68cac7"}[chunkId] + ".chunk.js";
};